import { useEffect, useState } from "react";
import { RestS } from "../../../rest/rest-service";
import PcHome from "../home/PcHome";
import PcSections from "./PcSections";
import { Navigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import usePageTitle from "../../../components/Hooks/usePageTitle";




const PcSectionWrapper = () => {
    const [isFirstUser, setIsFirstUser] = useState(false);
    const [loading, setLoading] = useState(true);
    const [redirectToHome, setRedirectToHome] = useState(false);
    const [pcColdState, setPcColdState] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const pageTitle = usePageTitle('P&L Tracker | Merito');


    // const checkGetStarted = async () => {
    //     try {
    //         const { allowGetStarted, coldState, isFirstUser, redirectToHome } = await RestS.checkPcGetStarted();
    //         setIsFirstUser(isFirstUser);
    //         setRedirectToHome(redirectToHome);
    //         setPcColdState(coldState);
    //     } catch (error) {
    //         console.log('error', error)
    //     }
    // }

    useEffect(() => {
        let isMounted = true;
        const checkGetStarted = async () => {
            try {
                const response = await RestS.checkPcGetStarted();
                // const [] = await Promise.all([])

                if (isMounted) { // Only update state if the component is still mounted
                    setIsFirstUser(response.isFirstUser);
                    setRedirectToHome(response.redirectToHome);
                    setLoading(false); // Set loading to false regardless of outcome
                }
            } catch (error) {
                console.error('error', error);
                setLoading(false); // Ensure loading is set to false even on error
            }
        };
        checkGetStarted();

        return () => { isMounted = false; pageTitle('') };
    }, []);

    // console.log('redirectToHome', redirectToHome)

    // Render logic
    if (loading) {
        return <div></div>;
    }

    if (redirectToHome) {
        return <Navigate to="/pnltracker" replace />;
    }

    // If not loading, not redirecting to home, render PcSections
    return <PcSections isFirstTimeUser={isFirstUser} />;
}

export default PcSectionWrapper;